
<template>
  <div v-if="isLoading" class="loading-bar">
    <div class="progress">
      <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :style="{ width: progress + '%' }"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    progress: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped>
.loading-bar {
  width: 100%;
  margin-top: 10px;
}

.progress {
  height: 8px;
}

.progress-bar {
  background-color: #45d615;
}
</style>